/**
 * @packageDocumentation
 * @module api.functional.admin.users.settings.timezone
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { UpdateTimezoneDto } from "../../../../../structures/UpdateTimezoneDto";
import type { UserTimezoneResponseDto } from "../../../../../structures/UserTimezoneResponseDto";

/**
 * @controller UserController.updateTimezone
 * @path PATCH /admin/users/settings/timezone
 * @accessor api.functional.admin.users.settings.timezone.updateTimezone
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function updateTimezone(
  connection: IConnection,
  body: updateTimezone.Body,
): Promise<updateTimezone.Output> {
  return PlainFetcher.fetch(
    {
      ...connection,
      headers: {
        ...connection.headers,
        "Content-Type": "application/json",
      },
    },
    {
      ...updateTimezone.METADATA,
      template: updateTimezone.METADATA.path,
      path: updateTimezone.path(),
    },
    body,
  );
}
export namespace updateTimezone {
  export type Body = UpdateTimezoneDto;
  export type Output = UserTimezoneResponseDto;

  export const METADATA = {
    method: "PATCH",
    path: "/admin/users/settings/timezone",
    request: {
      type: "application/json",
      encrypted: false,
    },
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = () => "/admin/users/settings/timezone";
}
